import { useNavigate } from "react-router-dom";
import { WhatsAppChat } from "@/components/crm/chat/WhatsAppChat";

export default function ChatPage() {
  const navigate = useNavigate();
  return <WhatsAppChat fullScreen onClose={() => (window.history.length > 1 ? navigate(-1) : navigate("/"))} />;
}
